module.exports = __webpack_public_path__ + "c4c01c12c23cabd413419a4b1dccd3c3.svg";